import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PortalPageHeader } from "@/components/portal/PortalLayout";
import { StatBadge } from "@/components/admin/AdminLayout";
import { Users, Car, Wallet, TrendingUp } from "lucide-react";

export default function FleetDashboard() {
  const [me, setMe] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [earnings, setEarnings] = useState(null);
  useEffect(() => {
    api.get("/fleet/me").then((r) => setMe(r.data));
    api.get("/fleet/drivers").then((r) => setDrivers(r.data));
    api.get("/fleet/vehicles").then((r) => setVehicles(r.data));
    api.get("/fleet/earnings").then((r) => setEarnings(r.data));
  }, []);
  if (!me) return <div className="p-10 text-slate-500">Loading…</div>;
  const pending = drivers.filter(d => d.status === "pending").length;
  return (
    <div className="p-10 max-w-[1400px]">
      <PortalPageHeader eyebrow={me.company_name} title="Fleet Dashboard" description="Manage your drivers and vehicles. All new additions require DiTours admin approval." />
      <div className="grid grid-cols-4 gap-5 mb-8">
        <Kpi label="Drivers" value={drivers.length} sub={`${pending} pending`} icon={Users} />
        <Kpi label="Vehicles" value={vehicles.length} icon={Car} />
        <Kpi label="Fleet commission" value={`€${(earnings?.total || 0).toFixed(2)}`} icon={Wallet} accent />
        <Kpi label="Trips" value={earnings?.bookings_count || 0} icon={TrendingUp} />
      </div>
      <div className="bg-white border border-slate-200 p-6 shadow-sm">
        <p className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold mb-4">Driver earnings breakdown</p>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
              <th className="p-3">Driver</th>
              <th className="p-3 text-right">Trips</th>
              <th className="p-3 text-right">Driver earned</th>
              <th className="p-3 text-right">Fleet commission</th>
            </tr>
          </thead>
          <tbody>
            {(earnings?.by_driver || []).length === 0 && <tr><td colSpan={4} className="p-6 text-center text-slate-500">No paid trips yet.</td></tr>}
            {(earnings?.by_driver || []).map((d) => (
              <tr key={d.driver_id} className="border-b border-slate-100">
                <td className="p-3 text-[#0a0f1e]">{d.name}</td>
                <td className="p-3 text-right text-slate-700">{d.trips}</td>
                <td className="p-3 text-right font-mono text-slate-700">€{d.earnings.toFixed(2)}</td>
                <td className="p-3 text-right font-mono text-[#f59e0b]">€{d.fleet_commission.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Kpi({ label, value, sub, icon: Icon, accent }) {
  return (
    <div className={`bg-white border p-6 shadow-sm ${accent ? "border-[#f59e0b]" : "border-slate-200"}`}>
      <div className="flex items-center justify-between mb-3"><span className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</span><Icon className={`w-4 h-4 ${accent ? "text-[#f59e0b]" : "text-slate-400"}`} strokeWidth={1.5} /></div>
      <div className={`font-display text-3xl ${accent ? "text-[#f59e0b]" : "text-[#0a0f1e]"}`}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}
